import { ref } from 'vue';
import service from '@/services';
import { isWebAuthnSupported, startRegistration } from './useWebAuthn';

export function usePasskeys() {
  const passkeys = ref([]);
  const isLoading = ref(false);
  const error = ref(null);

  async function fetchPasskeys() {
    isLoading.value = true;
    error.value = null;
    try {
      const res = await service.get('/passkeys');
      passkeys.value = res.data.data || [];
    } catch (err) {
      error.value = err.response?.data?.message || 'Failed to load passkeys.';
    } finally {
      isLoading.value = false;
    }
  }

  async function registerPasskey(name) {
    if (!isWebAuthnSupported()) {
      throw new Error('WebAuthn is not supported in this browser.');
    }

    const optionsRes = await service.post('/passkeys/register/options');
    const options = optionsRes.data;

    const credential = await startRegistration(options);

    await service.post('/passkeys/register', { ...credential, friendly_name: name });
  }

  async function removePasskey(id) {
    await service.delete(`/passkeys/${id}`);
    passkeys.value = passkeys.value.filter((p) => p.id !== id);
  }

  async function getAuthenticationOptions() {
    const res = await service.post('/passkeys/authenticate/options');
    return res.data;
  }

  async function verifyAuthentication(credential) {
    const res = await service.post('/passkeys/authenticate', credential);
    return res.data;
  }

  return {
    passkeys,
    isLoading,
    error,
    fetchPasskeys,
    registerPasskey,
    removePasskey,
    getAuthenticationOptions,
    verifyAuthentication,
  };
}
